import { Typography } from '@mui/material';
import { useFieldHelper, TextField } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { ShowDate } from 'framework/ui/ui-builder';
import { ProjectDashboardCycleStatus } from '../../ProjectDashboardService';

interface ProjectDashboardDateFieldProps {
  source: string;
  sourceOnTime: string;
  sourceCycleStatus: string;
  [key: string]: any;
}

const ProjectDashboardDateField = ({ source, sourceOnTime, sourceCycleStatus }: ProjectDashboardDateFieldProps) => {
  const { getValue: getOnTime } = useFieldHelper({ source: sourceOnTime });
  const { getValue: getCycleStatus } = useFieldHelper({ source: sourceCycleStatus });
  const { getValue: getDate } = useFieldHelper({ source });
  let component = <TextField value={getDate()} />;

  if (getCycleStatus() !== ProjectDashboardCycleStatus.FUTURE) {
    if (getDate()) {
      component = (
        <ShowDate
          dateUTC={getDate()}
          format={DATE_FORMAT.FULL_DATE}
          isDateTime={false}
          variant="inherit"
          data-date-status={getOnTime() ? 'on-time' : 'with-delay'}
          sx={{ color: getOnTime() ? 'success.main' : 'warning.main' }}
        />
      );
    } else if (getCycleStatus() !== ProjectDashboardCycleStatus.ACTIVE) {
      component = (
        <Typography component="span" variant="inherit" data-date-status="no-data" color="error">
          No data
        </Typography>
      );
    }
  }

  return component;
};

export default ProjectDashboardDateField;
